import React from 'react';
import { X, MessageCircle, Calendar, PhoneCall, Headphones, ArrowRight } from 'lucide-react';

interface CallWerfplaatsModalProps {
  onClose: () => void;
  contextInfo?: string; // Optional context, like vacancy title
}

export default function CallWerfplaatsModal({ onClose, contextInfo }: CallWerfplaatsModalProps) {
  const defaultSubject = encodeURIComponent(`Hulp nodig via Werftools${contextInfo ? ` over: ${contextInfo}` : ''}`);

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/40 backdrop-blur-sm animate-fadeIn">
      <div className="bg-white rounded-3xl w-full max-w-lg overflow-hidden shadow-2xl relative animate-slideUp">
        <button
          onClick={onClose}
          className="absolute right-4 top-4 w-8 h-8 flex items-center justify-center rounded-full bg-slate-100 text-slate-500 hover:bg-slate-200 hover:text-slate-900 transition-colors z-10"
        >
          <X size={16} />
        </button>

        <div className="bg-gradient-to-br from-red-50 to-orange-50/30 p-8 pb-6 text-center border-b border-red-100">
          <div className="w-16 h-16 bg-white rounded-2xl shadow-sm border border-red-100 flex items-center justify-center mx-auto mb-4 text-[#e51b23]">
            <Headphones size={32} />
          </div>
          <h2 className="text-2xl font-black text-slate-900 mb-2 tracking-tight">Call Werfplaats</h2>
          <p className="text-slate-500 text-sm font-medium">Direct schakelen met een recruitment expert. Kies hoe je contact wilt opnemen.</p>
        </div>

        <div className="p-6 space-y-3 bg-white">
          <a
            href={`https://wa.me/31612345678?text=${defaultSubject}`} // TODO: Replace with actual WA number
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-4 p-4 rounded-2xl border border-slate-200 hover:border-green-400 hover:bg-green-50 transition-all group cursor-pointer"
          >
            <div className="w-12 h-12 bg-green-100 text-green-600 rounded-xl flex items-center justify-center shrink-0">
              <MessageCircle size={24} />
            </div>
            <div className="flex-1">
              <h3 className="text-sm font-bold text-slate-900 flex items-center gap-2">WhatsApp Chat <span className="bg-green-100 text-green-700 text-[9px] px-1.5 py-0.5 rounded font-black uppercase tracking-wider">Snelste</span></h3>
              <p className="text-xs text-slate-500 font-medium">Direct antwoord op je vragen</p>
            </div>
            <ArrowRight size={16} className="text-slate-300 group-hover:text-green-500 group-hover:translate-x-1 transition-all" />
          </a>

          <a
            href={`mailto:petergobbels@bwnidea.nl?subject=${defaultSubject}`}
            className="flex items-center gap-4 p-4 rounded-2xl border border-slate-200 hover:border-blue-400 hover:bg-blue-50 transition-all group cursor-pointer"
          >
            <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-xl flex items-center justify-center shrink-0">
              <Calendar size={24} />
            </div>
            <div className="flex-1">
              <h3 className="text-sm font-bold text-slate-900">Afspraak Inplannen</h3>
              <p className="text-xs text-slate-500 font-medium">Plan een videocall of meeting</p>
            </div>
            <ArrowRight size={16} className="text-slate-300 group-hover:text-blue-500 group-hover:translate-x-1 transition-all" />
          </a>

          <a
            href="tel:+31612345678" // TODO: Replace with actual phone number
            className="flex items-center gap-4 p-4 rounded-2xl border border-slate-200 hover:border-orange-400 hover:bg-orange-50 transition-all group cursor-pointer"
          >
            <div className="w-12 h-12 bg-orange-100 text-orange-600 rounded-xl flex items-center justify-center shrink-0">
              <PhoneCall size={24} />
            </div>
            <div className="flex-1">
              <h3 className="text-sm font-bold text-slate-900">Direct Bellen</h3>
              <p className="text-xs text-slate-500 font-medium">Ma t/m Vr van 09:00 - 17:00</p>
            </div>
            <ArrowRight size={16} className="text-slate-300 group-hover:text-orange-500 group-hover:translate-x-1 transition-all" />
          </a>
        </div>
      </div>
    </div>
  );
}
